import UpsellModal from './upsell-modal';

export {
  PLANS,
  includedInAllPlansModalConfig,
  quotaModalConfig,
  quotaModalAtLimitConfig,
  teamsModalConfig,
  standardAndAboveModalConfig,
  advancedAndEnterpriseModalConfig,
  PLANS_DEFAULT_FEATURES,
} from './utils/constants';
export type { TemplateType, modalProps, TrackingProps } from './utils/interface';
export default UpsellModal;
